import { render, staticRenderFns } from "./QandAActivity.vue?vue&type=template&id=8dc8a564&"
import script from "./QandAActivity.vue?vue&type=script&lang=js&"
export * from "./QandAActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports